import { useSettingsStore } from './useSettingsStore';

// This hook returns a string representing the hash used in the router settings.
// It uses the useSettingsStore hook to access the state and retrieve the hash value.
export function useHash(): string {
  // Destructure the state from the useSettingsStore hook
  const { state } = useSettingsStore();

  // Return the hash value from the router settings
  return state.settings.router.useHash();
}

// Example usage of the useHash hook:
// const hash = useHash();
